<h1 *ngIf="data.title && data.title !== ''" class="dialogTitle textCenter" mat-dialog-title>
  <div #title >
    {{data.title}}
  </div>
</h1>

<div *ngIf="data.text && data.text !== ''" class="dialogText textCenter" mat-dialog-content>
  <div #text > {{data.text}} </div>
</div>

<div class="buttonContainer" mat-dialog-actions>
  <button *ngIf="data.cancel && data.cancel !== ''" class="button cancelButton" (click)="onCancel()"> {{data.cancel}} </button>
  <button *ngIf="data.confirm && data.confirm !== ''" class="button confirmButton" (click)="onConfirm()"> {{data.confirm}} </button>
</div>
